import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_adcrph7h: FaireBrandEntity = {
  token: "b_adcrph7h",
  type: "brand",
  name: "Seattle Chocolate Presents Maeve",
  avatarUrl:
    "https://cdn.faire.com/fastly/2967b1a1a414b4329dbb6ca952f7823c3ce42d2419ca485a866fd5d541b866dd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dfa2fa2267814a4121586834c443f704ee2411d334e150c6045d62c1f3331266.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2967b1a1a414b4329dbb6ca952f7823c3ce42d2419ca485a866fd5d541b866dd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dfa2fa2267814a4121586834c443f704ee2411d334e150c6045d62c1f3331266.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 396,
  isTopShop: true,
  isInsider: true,
  description:
    "Seattle Chocolate is now Maeve Chocolate - where we believe you can have it all. We’re championing ethical practices while cheering on your taste buds. We’re empowering women and giving them a moment of peace when they get home. We rally around our community, we show up, we bring treats. We’re environmentally friendly and also just like, regular friendly. When you pick Maeve you’re choosing a sustainably sourced, eco-conscious, woman-owned brand – and you’re also choosing FUN. The best flavors, the best taste, the cutest packaging. \n\nKNOW US AS SEATTLE CHOCOLATE? Still us—we’ve simply rebranded to reach more people across the country. The heart of who we are hasn’t changed; you’ll still find our iconic truffle bars, thoughtfully maximalist packaging, commitment to sustainability, and our 10% giveback to cocoa farmers. We've kept our best-selling bars, and introduced bold new flavors and giftable treats to fall in love with. Scoot over, we brought treats.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:02.254Z",
    importedBy: "entity-db-cli",
  },
};
